/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./src/css/global.scss"

export const shouldUpdateScroll = () => {
  return false
}
